import { z } from "zod/v4";

import { OrganizationDtoSchema } from "../../../dtos/organizations";
import { UserDtoSchema } from "../../../dtos/users";

export const LoginRequestBodySchema = z.object({
  token: z.string().nullish(),
  email: z.email().nullish(),
  password: z.string().nullish(),
  orgId: z.string().nullish(),
  shopId: z.string().nullish(),
  experienceId: z.string().nullish(),
  reAuth: z.boolean().nullish(),
  returnUrl: z.string().nullish(),
});

export const LoginResponseBodyUserSchema = z.object({
  type: z.literal("login"),
  token: z.string(),
  user: UserDtoSchema,
  organization: OrganizationDtoSchema,
  chameleonHmac: z.string().nullish(),
});

export const LoginResponseBodyRequestSchema = z.object({
  type: z.literal("redirect"),
  redirect: z.string(),
});

export const LoginResponseBodyClearSchema = z.object({
  type: z.literal("clear"),
  redirect: z.string(),
});

export const LoginResponseBodySchema = z.discriminatedUnion("type", [
  LoginResponseBodyUserSchema,
  LoginResponseBodyRequestSchema,
  LoginResponseBodyClearSchema,
]);

export type LoginRequestBodyType = z.infer<typeof LoginRequestBodySchema>;
export type LoginResponseBodyType = z.infer<typeof LoginResponseBodySchema>;
export type LoginResponseBodyUserType = z.infer<
  typeof LoginResponseBodyUserSchema
>;
export type LoginResponseBodyRedirectType = z.infer<
  typeof LoginResponseBodyRequestSchema
>;

export type LoginResponseForceLogout = {
  redirect: string;
};
